import { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useButton } from 'react-aria';
import useAuth from 'client/utils/auth/useAuth';

import Dialog from 'client/components/aria/Dialog/Dialog';
import Alert from 'client/components/ui/Alert/Alert';
import ButtonGroup from 'client/components/aria/ButtonGroup/ButtonGroup';
import Button from 'client/components/aria/Button/Button';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from '../SignInOut.module.scss';

const SignOut = (props) => {
    const intl = useIntl();
    const [open, setOpen] = useState(false);
    const ref = useRef();
    const { signOutByChoice } = useAuth();

    const { buttonProps } = useButton({
        ...props,
        elementType: 'a',
        onPress: () => setOpen(true)
    }, ref);

    return (
        <>
            <li
                data-testid="navbar.link.signout"
                className="govuk-header__navigation-item"
                role="none"
            >
                <a
                    ref={ref}
                    {...buttonProps}
                    className={[styles.pointer, 'govuk-header__link'].join(' ')}
                    role="menuitem"
                    data-testid="navbar.link.signout.link"
                >
                    {intl.formatMessage({ id: 'general.signOut' })}
                </a>
            </li>
            <Dialog
                data-testid="navbar.signout.dialog"
                isOpen={open}
                onClose={() => setOpen(false)}
                isDismissable
                role={'alertdialog'}
                aria-labelledby={'sign.out.dialog.title'}
            >
                <Alert role="document">
                    <h2
                        id="sign.out.dialog.title"
                        data-testid="signout.title"
                        className={[styles.title, 'govuk-error-summary__title'].join(' ')}
                    >
                        {intl.formatMessage({ id: 'signOut.title' })}
                    </h2>

                    <ButtonGroup className={styles.actionRow}>
                        <Button
                            onPress={() => setOpen(false)}
                            variant="error"
                            data-testid="signOut.button.disagree"
                            aria-label={intl.formatMessage({ id: 'signOut.button.disagree.ariaLabel' })}
                        >
                            {intl.formatMessage({ id: 'general.cancel' })}
                        </Button>
                        <Button
                            onPress={signOutByChoice}
                            variant="success"
                            data-testid="signOut.button.agree"
                            aria-label={intl.formatMessage({ id: 'signOut.button.agree.ariaLabel' })}
                        >
                            {intl.formatMessage({ id: 'agree' })}
                        </Button>
                    </ButtonGroup>
                </Alert>
            </Dialog>
        </>
    );
};

SignOut.propTypes = {
    ...defaultAriaProps
};

export default SignOut;
